function ShortTextIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.33331 10C1.33331 9.63182 1.63179 9.33334 1.99998 9.33334H11.3333C11.7015 9.33334 12 9.63182 12 10C12 10.3682 11.7015 10.6667 11.3333 10.6667H1.99998C1.63179 10.6667 1.33331 10.3682 1.33331 10Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.33331 6.66667C1.33331 6.29848 1.63179 6 1.99998 6H14C14.3682 6 14.6666 6.29848 14.6666 6.66667C14.6666 7.03486 14.3682 7.33333 14 7.33333H1.99998C1.63179 7.33333 1.33331 7.03486 1.33331 6.66667Z'
        />
      </svg>
    </span>
  );
}

export default ShortTextIcon;
